import { RouteConfig } from 'vue-router';
import Viewing from './ViewingPage.vue';
import NavigationViewing from './components/NavigationViewing.vue';
import Tables from './components/Tables.vue';
import Graphs from './components/Graphs.vue';
import ExcelExport from './components/ExcelExport.vue';
import About from './components/About.vue';

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Viewing',
        component: Viewing,
        children: [
            {
                path: 'tables',
                component: Tables,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'graphs',
                component: Graphs,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'excel',
                component: ExcelExport,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: 'about',
                component: About,
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: '',
                component: NavigationViewing,
                meta: {
                    requiresAuth: true,
                },
            },
        ]
    },
];

export default routes;